<template>
    <div class="top_mobile">
        <div class="top_mobilea" v-show="caidan == 1">
            <div class="top_mobileleft">
                <img
                        @click="jumpindex()"
                        src="../../public/statics/img/mobile/logo.png"
                        alt=""
                />
            </div>
            <div class="top_mobileright">
                <img
                        src="../../public/statics/img/mobile/icon_dengl.png"
                        alt=""
                        @click="caidan = 3"
                        v-if="status == 0"
                />
                <div class="top_mobilerightinfo" v-if="status == 1">
                    {{ name }}
                    <span @click="logout">退出</span>
                </div>
                <img
                        src="../../public/statics/img/mobile/icon_gengduo.png"
                        alt=""
                        @click="caidan = 2"
                />
            </div>
        </div>
        <div class="top_mobileb" v-show="caidan == 2" @touchmove.prevent>
            <div class="top_mobileb1">
                <div class="top_mobileb2">
                    <img
                            class="top_mobileb2img1"
                            src="../../public/statics/img/mobile/logo.png"
                            alt=""
                    />
                    <img
                            class="top_mobileb2img2"
                            src="../../public/statics/img/mobile/icon_guanbi.png"
                            alt=""
                            @click="caidan = 1"
                    />
                </div>
                <div class="top_mobileb2r">
                    <div class="top_mobileb2s" @click="jumppage(0)">
                        <img
                                src="../../public/statics/img/mobile/icon_shouye@2x.png"
                                alt=""
                        />
                        <span>首页</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(1)">
                        <img
                                src="../../public/statics/img/mobile/icon_jiaru@2x.png"
                                alt=""
                        />
                        <span>申请加入</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(2)">
                        <img
                                src="../../public/statics/img/mobile/icon_zhichi@2x.png"
                                alt=""
                        />
                        <span>支持中心</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(3)">
                        <img
                                src="../../public/statics/img/mobile/icon_zixun@2x.png"
                                alt=""
                        />
                        <span>资讯动态</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(4)">
                        <img
                                src="../../public/statics/img/mobile/icon_kefu@2x.png"
                                alt=""
                        />
                        <span>客服中心</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(5)">
                        <img
                                src="../../public/statics/img/mobile/shop.png"
                                alt=""
                        />
                        <span>生态云商城</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(7)">
                        <img
                                src="../../public/statics/img/loadimg.png"
                                alt=""
                        />
                        <span>云货主App</span>
                    </div>
                    <div class="top_mobileb2s" @click="jumppage(8)">
                        <img
                                src="../../public/statics/img/loadimg.png"
                                alt=""
                        />
                        <span>云车主App</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="top_mobilec" v-show="caidan == 3" @touchmove.prevent>
            <div class="top_mobilec1">
                <img
                        src="../../public/statics/img/mobile/icon_guanbi@2x.png"
                        alt=""
                        @click="caidan = 1"
                />
                <img
                        src="../../public/statics/img/mobile/icon_gengduo.png"
                        alt=""
                        @click="caidan = 2"
                />
            </div>
            <el-form ref="form" :model="form" style="width: 100%" :rules="rules">
                <div class="center">
                    <div class="center_img">
                        <p>登 录</p>
                    </div>
                    <div class="input_up">
                        <div class="input_up_style">
                            <p><span>*</span>账号:</p>
                            <el-form-item prop="phone" style="height: 100%">
                                <el-input v-model="form.phone" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <!--   <div class="input_up_style">
                                        <p><span>*</span>密码:</p>
                                        <el-form-item prop="password" style="height: 100%">
                                            <el-input type="password" v-model="form.password"
                                                      show-password
                                                      placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </div>-->
                        <div class="input_up_style">
                            <p><span>*</span>验证码:</p>
                            <el-form-item prop="code" style="height: 100%">
                                <div style="display: flex; justify-content: space-between">
                                    <el-input
                                            type="code"
                                            v-model="form.code"
                                            style="width: 14rem"
                                            placeholder="请输入"
                                    ></el-input>
                                    <el-button
                                            v-show="shows == true"
                                            type="primary"
                                            style="width: 6rem; padding: 0 10px"
                                            @click="getcode()"
                                    >获取验证码
                                    </el-button>
                                    <el-button
                                            v-show="shows == false"
                                            type="primary"
                                            style="width: 100px; padding: 0 10px"
                                    >{{ count }}秒
                                    </el-button>
                                </div>
                            </el-form-item>
                        </div>
                        <el-button type="primary" @click="submitForm" class="loginstyle"
                        >登录
                        </el-button>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    const TIME_COUNT = 60;
    import {auth, loginauth, anth} from "../request/api";
    import Cookies from "js-cookie";
    import {getToken, setToken, removeToken} from "../request/toekn";
    import {mapGetters} from "vuex";
    import {Toast} from "vant";

    export default {
        name: "top_mobile",
        data() {
            return {
                caidan: 1,

                //登录表单
                form: {
                    phone: "",
                    password: "",
                    code: "",
                },
                //登录验证
                rules: {
                    phone: [
                        {required: true, message: "请输入账号", trigger: "blur"},
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: "请输入正确的手机号",
                            trigger: "blur",
                        },
                    ],
                    /*  password: [
                                      {required: true, message: '请输入密码', trigger: 'blur'},
                                      {min: 6, max: 20, message: '长度在 6 到 20 位字符', trigger: 'blur'}
                                  ],*/
                    code: [{required: true, message: "请输入验证码", trigger: "blur"}],
                },

                //登录状态
                status: 0,
                count: "",
                shows: true,
            };
        },
        computed: {
            ...mapGetters(["name", "avatar", "companyname", "phone", "password"]),
        },
        created() {
            if (Cookies.get(getToken()) && getToken()) {
                this.status = 1;
                this.getuserinfo();
            }
        },
        mounted() {
        },
        methods: {
            //标签页
            jumppage(e) {
                setTimeout(() => {
                    this.caidan = 1;
                }, 300);
                if (e == 0) {
                    this.$router.push({path: "/index_mobile"});
                }
                else if (e == 1) {
                    this.$router.push({path: "/edition_mobile"});
                }
                else if (e == 2) {
                    this.$router.push({path: "/word_mobile"});
                }
                else if (e == 3) {
                    this.$router.push({path: "/newviews_mobile"});
                }
                else if (e == 4) {
                    this.$router.push({path: "/chat_mobile"});
                }
                else if (e == 5) {
                    this.$router.push({path: "/shop_mobile"});
                }
                else if (e == 7) {
                    this.$router.push({path: "/cargoOwner_mobile"});
                }
                else if (e == 8) {
                    this.$router.push({path: "/carOwner_mobile"});
                }
            },
            getuserinfo() {
                this.$store
                    .dispatch("GetInfo")
                    .then((data) => {
                        // console.log('成功')
                    })
                    .catch((data) => {
                        if (data.data.code == 8000) {
                            this.logout();
                            this.loading = false;
                        } else {
                            console.log(1);
                            this.$message.error(data);
                            this.loading = false;
                        }
                    });
            },
            //登录表单提交
            submitForm(form) {
                // this.loading = true;
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        let code = {
                            phone: this.form.phone, //手机号
                            code: this.form.code, //公司编号
                            // password: this.form.password, //密码
                            type: 1,
                        };
                        Cookies.remove();
                        removeToken();

                        this.$store
                            .dispatch("Login", code)
                            .then((data) => {
                                if (Cookies.get(getToken()) && getToken()) {
                                    loginauth().then((res) => {
                                        if (res.data.code == 1) {
                                            let menus = res.data.data.menu;
                                            if (menus != "") {
                                                if (menus.user) {
                                                    Lockr.set("user", menus.user.children);
                                                }
                                                if (menus.transport) {
                                                    Lockr.set("transport", menus.transport.children);
                                                }
                                                if (menus.packing) {
                                                    Lockr.set("packing", menus.packing.children);
                                                }
                                            }
                                            this.getuserinfo();
                                            Toast.success("登录成功");
                                            this.status = 1;
                                            this.caidan = 1;
                                            this.$router.push({path: "/index_mobile"});
                                        } else {
                                            Toast.fail(res.data.msg);
                                            setTimeout(() => {
                                                this.logout();
                                            }, 500);
                                            return;
                                        }
                                    });
                                }
                            })
                            .catch((data) => {
                                // this.$message.error(data);
                                Toast.fail(data);
                                this.loading = false;
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            // 退出登录
            logout() {
                this.$store
                    .dispatch("LogOut")
                    .then((data) => {
                        Toast.success("退出成功");
                        this.caidan = 1;
                        this.status = 0;
                        this.$router.push({path: "/index_mobile"});
                    })
                    .catch((data) => {
                        Toast.fail(data.data.msg);
                    });
            },
            //获取验证码
            getcode() {
                if (this.form.phone == undefined || this.form.phone == "") {
                    Toast.fail("请输入手机号");
                } else {
                    let url = "/v1/member/login/send_sms";
                    let data = {
                        phone: this.form.phone,
                        type: 1,
                    };
                    auth(url, data).then((res) => {
                        if (res.data.code == 1) {
                            this.count = TIME_COUNT;
                            this.shows = false;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    this.shows = true;
                                    clearInterval(this.timer); // 清除定时器
                                    this.timer = null;
                                }
                            }, 1000);
                        } else {
                            Toast(res.data.msg);
                        }
                    });
                }
            },
            //
            jumpindex() {
                this.$router.push("/index_mobile");
            },
        },
    };
</script>

<style scoped lang='scss'>
    .top_mobile {
        .top_mobilea {
            z-index: 8;
            position: fixed;
            padding: 10px;
            height: 44px;

            width: 24rem;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .top_mobileleft {
                img {
                    width: 60px;
                }
            }

            .top_mobileright {
                display: flex;
                align-items: center;

                .top_mobilerightinfo {
                    color: #ffffff;
                    font-family: "PingFang SC";
                    font-size: 14px;
                    margin-right: 1rem;
                }

                img {
                    width: 16px;
                    height: 16px;
                }

                img:first-child {
                    width: 16px;
                    height: 16px;
                    margin-right: 0.5rem;
                }
            }
        }

        .top_mobileb {
            z-index: 8;
            position: fixed;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            box-sizing: border-box;

            .top_mobileb1 {
                width: 100%;
                height: auto;
                padding-bottom: 2rem;

                .top_mobileb2 {
                    width: 24rem;
                    padding: 10px;
                    height: 44px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    background: #202334;

                    .top_mobileb2img1 {
                        width: 60px;
                        height: auto;
                    }

                    .top_mobileb2img2 {
                        width: 16px;
                        height: 16px;
                    }
                }

                .top_mobileb2r {
                    position: absolute;
                    right: 0;
                    width: 150px;
                    box-sizing: border-box;
                    background: #202334;

                    .top_mobileb2s {
                        width: 130px;
                        height: auto;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                        margin: 10px;
                        padding: 10px;
                        box-sizing: border-box;

                        img {
                            width: 16px;
                            margin-right: 10px;
                        }

                        img:first-child {
                            width: 16px;
                            height: 16px;
                        }

                        span {
                            font-size: 14px;
                        }

                        color: #ffffff;
                    }
                }
            }
        }

        .top_mobilec {
            z-index: 8;
            position: fixed;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;
            /*background:#cccccc;*/
            box-sizing: border-box;
            background-image: url("../../public/statics/img/mobile/beijin.png");
            background-size: auto 100vh;

            .top_mobilec1 {
                padding: 10px;
                height: 44px;
                box-sizing: border-box;
                width: 24rem;
                display: flex;
                justify-content: space-between;
                align-items: center;

                img {
                    width: 16px;
                    height: 16px;
                }
            }

            .center {
                width: 100%;
                height: auto;
                padding: 0 20px 0 20px;
                box-sizing: border-box;
                margin-top: 6px;

                .center_img {
                    width: 100%;
                    height: 39px;
                    display: flex;
                    /*margin-bottom: 11px;*/
                    justify-content: center;
                    margin: 30px 0 10px;

                    p {
                        width: auto;
                        height: 50px;
                        font-size: 30px;
                        font-family: "PingFang SC";
                        /*font-weight: bold;*/
                        line-height: 41px;
                        color: #ffffff;
                        letter-spacing: 5px;
                    }
                }

                .input_up {
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .input_up_style {
                        height: 94px;
                        display: flex;
                        flex-direction: column;

                        p {
                            font-size: 14px;
                            font-family: "PingFang SC";
                            line-height: 24px;
                            color: #fff;
                            text-align: left;

                            span {
                                color: #f35959;
                                margin-right: 5px;
                            }
                        }
                    }

                    .input_up_style1 {
                        height: 16px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        div {
                            display: flex;

                            i {
                                font-size: 16px;
                                color: #fba962;
                                line-height: 20px;
                            }

                            p {
                                font-size: 14px;
                                font-family: "PingFang SC";
                                color: #606266;
                                line-height: 20px;
                            }
                        }

                        span {
                            font-size: 14px;
                            line-height: 20px;
                            font-family: "PingFang SC";
                            color: #3d68eb;
                            cursor: pointer;
                        }
                    }

                    .loginstyle {
                        width: 100%;
                        height: 42px;
                        padding: 0 10px;
                        font-size: 16px;
                        cursor: pointer;
                        margin-top: 20px;
                    }
                }

                .center_bottom {
                    width: 100%;
                    height: 16px;
                    margin-top: 50px;
                    display: flex;
                    justify-content: space-between;

                    .jump-icon {
                        background: #666;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 14px;
                        height: 14px;
                        font-size: 10px;
                        color: #fff;
                        margin-right: 5px;
                    }

                    .jump-bar {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #595959;
                        padding-right: 10px;
                        cursor: pointer;
                    }

                    .jump-bar:hover {
                        color: #66b1e1;
                    }
                }
            }
        }
    }
</style>
